export default __webpack_public_path__ + "static/media/zip.81eef468.svg";